// Assign msCrypto to window.crypto if missing
if ((typeof window.crypto === "undefined" || typeof window.crypto.subtle === "undefined") && typeof window.msCrypto !== "undefined" && typeof window.msCrypto.subtle !== "undefined") {
  var ie11PromiseSubtle = {};
  function wrapOperation(operation) {
    return new Promise(function (resolve, reject) {
      operation.oncomplete = function (evt) {
        resolve(evt.target.result);
      };
      operation.onerror = function (evt) {
        reject(evt.target.error);
      };
    });
  }

  // List of SubtleCrypto methods to proxy
  var methods = [
    'encrypt', 'decrypt', 'digest',
    'sign', 'verify', 'deriveKey', 'deriveBits',
    'generateKey', 'importKey', 'exportKey', 'wrapKey', 'unwrapKey'
  ];

  var msSubtle = window.msCrypto.subtle;

  // Copy supported methods into the polyfill object
  methods.forEach(function (name) {
    if (typeof msSubtle[name] === 'function') {
      ie11PromiseSubtle[name] = function () {
        var op = msSubtle[name].apply(msSubtle, arguments);
        return wrapOperation(op);
      };
    }
  });

  if (window.crypto) {
    window.crypto.subtle = ie11PromiseSubtle;
  } else {
    window.crypto = {
      subtle: ie11PromiseSubtle, getRandomValues: function (/* … */) {
        return window.msCrypto.getRandomValues.apply(window.msCrypto, arguments);
      }
    };
  }
}
